import {MenuNode, MenuNodeCfgSet, Task} from "./types.ts";
import * as React from "react";

interface PropTypes {
    menuNode: MenuNode,
    menuNodeCfgSet: MenuNodeCfgSet,
    setMenuNodeCfgSet: React.Dispatch<React.SetStateAction<MenuNodeCfgSet>>,
    tasks: Record<number, Task>,
    HEADING_COL_WIDTH: number,
    showClientTags: boolean
}

export function UtilisationMenuItemHeading({
                                               menuNode,
                                               setMenuNodeCfgSet,
                                               menuNodeCfgSet,
                                               tasks,
                                               HEADING_COL_WIDTH,
                                               showClientTags
                                           }: PropTypes) {
    if (menuNode && !menuNodeCfgSet[menuNode.key]) menuNodeCfgSet[menuNode.key] = {};
    const cfg = menuNodeCfgSet[menuNode?.key];

    let link = '';

    switch (menuNode.subLevelGroup) {
        case "enq":
            link = `/enquiry/${menuNode.id}/proposal`
            break;
        case "job":
            link = `/job/${menuNode.id}/tasks?task_filter[staffList]=${menuNode.rootLevelId}&task_filter[status][]=In Progress&task_filter[status][]=Overdue&task_filter[status][]=Assigned&task_filter[status][]=Proposed&task_filter[status][]=On Hold`
            break;
        case "task":
            const task: Task = tasks[menuNode.id]
            link = task.proposedTask ?
                `/enquiry/${task.fkEnqid}/proposal` :
                `/task/edit/${menuNode.id}`


    }

    return (
        <div
            title={menuNode.errorString}
            style={{
                paddingLeft: menuNode.level + (showClientTags && menuNode.level > 2 ? 3.5 : 0) +  'rem',
                width: `${HEADING_COL_WIDTH - 72}px`,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: 23,

            }}
        >
            {
                menuNode.subLevelGroup == 'group' ?
                    <strong>{menuNode.name}</strong> :
                    menuNode.subLevelGroup === 'task' ?
                        <a className='link-dark link-underline-opacity-25 w-100' href={link} title={menuNode.errorString || 'Go To Task'}
                           target='_blank'>{menuNode.name}</a> :
                        (menuNode.subLevelGroup === 'enq' || menuNode.subLevelGroup === 'job') ?
                            <span style={{overflow: 'hidden'}}>
                                    {showClientTags &&
                                        <span
                                            className='d-inline-flex justify-content-end'
                                              style={{width: '5em'}}>
                                            <span
                                                className="text-body-secondary border border-1 border-light-subtle rounded-1 ps-1 pe-1 me-1"
                                                style={{fontSize: '0.8em', textAlign: 'right'}}
                                            >
                                                {menuNode.cliCode}
                                            </span>
                                        </span>
                                    }
                                {menuNode.name}
                                 </span> :
                            <span style={{overflow: 'hidden'}}>
                                    {menuNode.name}
                                 </span>

            }
            {(menuNode.subLevelGroup === 'enq' || menuNode.subLevelGroup === 'job' || menuNode.level <= 1) &&
                <div className='menuActions position-relative'
                     style={{width: menuNode.level == 1 ? 63 : 84, height: 23}}>
                    {(menuNode.subLevelGroup === 'enq' || menuNode.subLevelGroup === 'job') &&
                        <a
                            className={`p-1 btn btn-sm border-0 btn-outline-secondary top-50 position-absolute end-0 translate-middle`}
                            title={`Go To ${menuNode.subLevelGroup === 'enq' ? 'Proposal' : 'Job Tasks'}`}
                            target="_blank"
                            style={{fontSize: 15, fontFamily: "'Wingdings 3'"}}
                            href={link}></a>
                    }
                    {(menuNode.level === 0 || menuNode.level === 1) &&
                        <>
                            <UpButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (typeof cfg.openChildrenLevel !== 'number') cfg.openChildrenLevel = menuNode.level - 1;
                                    cfg.openChildrenLevel = Math.max(cfg.openChildrenLevel - 1, menuNode.level - 1);

                                    if (cfg.openChildrenLevel < menuNode.level && menuNode.id != 'mel') cfg.open = false;

                                    openCloseMenuNodesBasedOnLevel(menuNode.children, menuNodeCfgSet, cfg.openChildrenLevel);
                                    setMenuNodeCfgSet({...menuNodeCfgSet});
                                }}
                            />
                            <DownButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    let highestLevel = menuNode.level;
                                    if (typeof cfg.openChildrenLevel !== 'number') cfg.openChildrenLevel = menuNode.level - 1;
                                    if (cfg.open && cfg.openChildrenLevel < menuNode.level && menuNode.id != 'mel') cfg.openChildrenLevel = menuNode.level;


                                    cfg.openChildrenLevel = cfg.openChildrenLevel + 1;
                                    if (cfg.openChildrenLevel >= menuNode.level) cfg.open = true;

                                    highestLevel = openCloseMenuNodesBasedOnLevel(menuNode.children, menuNodeCfgSet, cfg.openChildrenLevel);

                                    cfg.openChildrenLevel = Math.min(highestLevel - 1, cfg.openChildrenLevel);
                                    setMenuNodeCfgSet({...menuNodeCfgSet});
                                }}
                            />
                        </>
                    }
                    {menuNode.level === 0 &&
                        <MultiGraphButton
                            onClick={(e) => {
                                e.stopPropagation();
                                cfg.graphChildren = !cfg.graphChildren;
                                menuNode.children.forEach(childItem => {
                                    if (!menuNodeCfgSet[childItem.key]) menuNodeCfgSet[childItem.key] = {}
                                    menuNodeCfgSet[childItem.key].graph = cfg.graphChildren;
                                })
                                if (!cfg.open && cfg.graphChildren) cfg.open = true;
                                setMenuNodeCfgSet({...menuNodeCfgSet});
                            }}
                            active={cfg.graphChildren}
                        />
                    }
                    {(menuNode.level === 0 || menuNode.level === 1) &&
                        <GraphButton
                            onClick={(e) => {
                                e.stopPropagation();
                                cfg.graph = !cfg.graph;
                                setMenuNodeCfgSet({...menuNodeCfgSet});
                            }}
                            active={cfg.graph}
                        />
                    }
                </div>
            }
        </div>
    )

}

function GraphButton({active, ...props}) {
    return <button
        type='button'
        className={`p-1 btn btn-sm border-0 btn-outline-secondary top-50 position-absolute end-0 translate-middle ${active ? 'active' : ''}`}
        style={{lineHeight: 0}}
        {...props}
    >
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 512 512"
             style={{width: '13px'}}
        >
            <path
                fill='currentColor'
                d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"/>
        </svg>
    </button>

}

function MultiGraphButton({active, ...props}) {
    return <button
        type='button'
        className={`p-1 btn btn-sm border-0 btn-outline-secondary top-50 position-absolute translate-middle ${active ? 'active' : ''}`}
        style={{lineHeight: 0, left: 42}}
        {...props}
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{width: 13}}>
            <path fill="currentColor"
                  d="M 64 64 c 0 -17.7 -14.3 -32 -32 -32 S 0 46.3 0 64 V 400 c 0 44.2 35.8 80 80 80 H 480 c 17.7 0 32 -14.3 32 -32 s -14.3 -32 -32 -32 H 80 c -8.8 0 -16 -7.2 -16 -16 V 64 z
              m 406.6 170 c 12.5 -12.5 12.5 -32.8 0 -45.3 s -32.8 -12.5 -45.3 0 l -105.3 105.4 l -57.4 -57.4 c -12.5 -12.5 -32.8 -12.5 -45.3 0 l -112 112 c -12.5 12.5 -12.5 32.8 0 45.3 s 32.8 12.5 45.3 0 l 89.4 -89.3 l 57.4 57.4 c 12.5 12.5 32.8 12.5 45.3 0 l 128 -128 z">
            </path>
            <path
                fill="currentColor"
                d="M64 65 m 406.6 32 c 12.5 -12.5 12.5 -32.8 0 -45.3 s -32.8 -12.5 -45.3 0 l -105.3 105.4 l -57.4 -57.4 c -12.5 -12.5 -32.8 -12.5 -45.3 0 l -112 112 c -12.5 12.5 -12.5 32.8 0 45.3 s 32.8 12.5 45.3 0 l 89.4 -89.3 l 57.4 57.4 c 12.5 12.5 32.8 12.5 45.3 0 l 128 -128 z">
            </path>
        </svg>
    </button>
}

function UpButton(props) {
    return <button
        type='button'
        className={`p-1 btn btn-sm border-0 btn-outline-secondary top-50 position-absolute translate-middle`}
        style={{lineHeight: '13px'}}
        {...props}
    >
        <span style={{display: 'inline-block', width: '13px', fontWeight: 'bold'}}>˄</span>
    </button>
}

function DownButton(props) {
    return <button
        type='button'
        className={`p-1 btn btn-sm border-0 btn-outline-secondary top-50 position-absolute translate-middle`}
        style={{lineHeight: '13px', left: '21px'}}
        {...props}
    >
        <span style={{display: 'inline-block', width: '13px', fontWeight: 'bold'}}>˅</span>
    </button>
}

/**
 * Returns highest highestLevel/depth of menunNode set
 * @param menuNodes
 * @param menuNodeCfgSet
 * @param level
 */
function openCloseMenuNodesBasedOnLevel(menuNodes: MenuNode[], menuNodeCfgSet: MenuNodeCfgSet, level: number): number {
    let highestLevel = 0;
    let returnedLevel = null;

    menuNodes.forEach(childItem => {
        if (!menuNodeCfgSet[childItem.key]) menuNodeCfgSet[childItem.key] = {}
        menuNodeCfgSet[childItem.key].open = (childItem.level <= level);

        if (childItem.level > highestLevel) highestLevel = childItem.level;
        if (childItem.level <= 1) menuNodeCfgSet[childItem.key].openChildrenLevel = level;

        if (childItem.children?.length) {
            returnedLevel = openCloseMenuNodesBasedOnLevel(childItem.children, menuNodeCfgSet, level);

            if (returnedLevel > highestLevel) highestLevel = returnedLevel;
        }
    })

    return highestLevel;
}
